import { LoadingOutlined } from "@ant-design/icons";
import { useAuth } from "context/AuthContextProvider";
import { Navigate, useLocation } from "react-router-dom";
import PATHS from "shared/constants/paths";

const ProtectedRoutes = ({ children }: any) => {
  const { state } = useAuth();
  const location = useLocation();

  if (state.isLoading) return <LoadingOutlined />;

  return state.user ? (
    children
  ) : (
    <Navigate to={PATHS.LOGIN} replace state={{ path: location.pathname, search: location.search }} />
  );
};

export default ProtectedRoutes;
